import HttpService from "./htttp.service";

class AuthService {
  authEndpoint = `${process.env.REACT_APP_API_URL}/login-pass`;

  login = async (userData) => {
    const response = await HttpService.post(this.authEndpoint, userData);
    const token = response.data.token;
    localStorage.setItem("access_token", token);
    return {
      access_token: token,
      user: response.data.admin,
    };
  };
  register = async (credentials) => {
    const registerEndpoint = 'register';
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const logoutEndpoint = `${process.env.REACT_APP_API_URL}/logout`;
    console.log("logout")
    return await HttpService.post(logoutEndpoint);

  };

  forgotPassword = async (payload) => {
    const forgotPassword = 'password-forgot';
    return await HttpService.post(forgotPassword, payload);
  }

  resetPassword = async (credentials) => {
    const resetPassword = 'password-reset';
    return await HttpService.post(resetPassword, credentials);
  }

  getProfile = async () => {
    const getProfile = `${process.env.REACT_APP_API_URL}/get-profile`;
    return await HttpService.post(getProfile);
  }

  updateProfile = async (newInfo) => {
    const updateProfile = "me";
    return await HttpService.patch(updateProfile, newInfo);
  }
}

export default new AuthService();

